module.exports = __webpack_public_path__ + "static/img/bg-search-danwei.d527717.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bg-search-danwei.png
// module id = 818
// module chunks = 0